import { Shield, LogOut } from 'lucide-react';

interface AdminBlockerProps {
  onGoToAdmin: () => void;
  onSignOut: () => void;
}

export function AdminBlocker({ onGoToAdmin, onSignOut }: AdminBlockerProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-8 max-w-md w-full text-center border border-purple-100">
        <div className="flex justify-center mb-6">
          <div className="bg-purple-100 p-4 rounded-full">
            <Shield className="w-12 h-12 text-purple-600" />
          </div>
        </div>
        
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">
          Administrator-konto
        </h1>
        
        <p className="text-gray-600 mb-8 leading-relaxed">
          Du er logget inn som administrator. Denne kontoen har ikke tilgang til app-funksjonaliteten.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={onGoToAdmin}
            className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full hover:shadow-lg transition-all font-medium"
          >
            Gå til Admin-dashboard
          </button>
          
          <button
            onClick={onSignOut}
            className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-full hover:bg-gray-50 transition-all font-medium flex items-center justify-center gap-2"
          >
            <LogOut className="w-4 h-4" />
            Logg ut
          </button>
        </div>
        
        <p className="text-xs text-gray-500 mt-6">
          For å bruke appen som vanlig bruker, logg inn med en annen konto.
        </p>
      </div>
    </div>
  );
}
